<template>
  <div style="background-color: #f6f7f9">
    <a-row class="nav" type="flex" justify="space-between" align="middle">
      <!-- 左边 -->
      <a-col>
        <span
          :class="{
            navButton: true,
            activedButton: activedHead === 'instances' ? true : false,
          }"
          @click="changePage('instances')"
          >模型</span
        >
        <span
          :class="{
            navButton: true,
            activedButton: activedHead === 'algorithms' ? true : false,
          }"
          @click="changePage('algorithms')"
          >机器学习算法</span
        >
        <span
          :class="{
            navButton: true,
            activedButton: activedHead === 'myInstances' ? true : false,
          }"
          @click="changePage('myInstances')"
          >我的模型</span
        >
        <span
          :class="{
            navButton: true,
            activedButton: activedHead === 'myCalc' ? true : false,
          }"
          @click="changePage('myCalc')"
          >计算记录</span
        >
        <span
          :class="{
            navButton: true,
            activedButton: activedHead === 'help' ? true : false,
          }"
          @click="changePage('help/index')"
          >文档</span
        >
      </a-col>

      <!-- 右边 -->
      <a-col
        :class="{
          navButton: true,
        }"
        @click="logout"
        >登出
      </a-col>
    </a-row>

    <a-row class="navHeight"></a-row>
  </div>
</template>

<script>
export default {
  name: 'nav-head',
  data() {
    return { activedHead: '' }
  },
  methods: {
    changePage(page) {
      // if (page === 'help') {
      //   this.$router.push('/help/index')
      // } else {
      //   this.$router.push('/' + page)
      // }
      this.$router.push('/' + page)
    },
    logout() {
      localStorage.setItem('accessToken', '')
      this.$http.defaults.headers.common.Authorization = ''
      this.$router.push('/login')
    }
  },
  mounted() {
    this.activedHead = this.$route.path.split('/')[1]
  }
}
</script>

<style scoped>
.nav {
  background-image: linear-gradient(to bottom right, #21213b, #3c3c66);
  /* background-color: royalblue; */
  font-size: 1.2rem;
  color: white;
  font-weight: 400;
  box-shadow: 0 0.8rem 0.5rem lightgray;
  position: fixed;
  width: 100%;
  z-index: 100;
  min-width: 40rem;
}
.navHeight {
  height: 5rem;
  min-width: 40rem;
}
.navButton {
  padding: 0.8rem 1rem 0.8rem 1rem;
  height: 100%;
}
.activedButton {
  background-color: slategrey;
  /* padding: 0.8rem 2rem 0.8rem 2rem; */
}
.navButton:hover {
  background-color: tan;
  /* padding: 0.8rem 2rem 0.8rem 2rem; */
  cursor: pointer;
}
</style>
